var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-top_svg__hand-top",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 2350"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hand-top_svg__cls-1{fill:#ffbfbf}.hand-top_svg__cls-2,.hand-top_svg__cls-4{fill:none}.hand-top_svg__cls-2{stroke:#1d1d1b;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3.13px}.hand-top_svg__cls-3{fill:#00fcab}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M451.07 556.18s14.29-7.18 13.72-15.1c-.52-7.37-2.83-14.16-10.75-15.85S443.85 523 443.85 523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M451.07 556.18s14.29-7.18 13.72-15.1c-.52-7.37-2.83-14.16-10.75-15.85S443.85 523 443.85 523"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M434.23 474.85s8.49-9.62 6.79-14.72-7.36-9.06-11.89-9.06-17.54-1.13-18.68 3.4c0 0-12.22 4.72-10.86 6.08s13.59 24.92 13.59 24.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M434.23 474.85s8.49-9.62 6.79-14.72-7.36-9.06-11.89-9.06-17.54-1.13-18.68 3.4c0 0-12.22 4.72-10.86 6.08s13.59 24.92 13.59 24.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M440.47 464.29s-9.06 1.13-11.89 2.83-7.93 8.49-7.93 8.49c1.7-1.7 16.42-2.26 26.61-2.26s11.89 5.09 14.72 11.88-21 27.17-21 27.17l-26.59 32-10.87 41.67s-111.89 14.5-113.25 13.14-40.77-97.85-40.77-97.85l32.16-138.61 90.6 116.42h43.94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M440.47 464.29s-9.06 1.13-11.89 2.83-7.93 8.49-7.93 8.49c1.7-1.7 16.42-2.26 26.61-2.26s11.89 5.09 14.72 11.88-21 27.17-21 27.17l-26.59 32-10.87 41.67s-111.89 14.5-113.25 13.14-40.77-97.85-40.77-97.85l32.16-138.61 90.6 116.42h43.94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-3",
    d: "M428.41 588.45l10.48 7.76s4.77 0 8.07 1.83 19.09 13.22 19.09 13.22a14.48 14.48 0 004 0c1.1-.37 7 3.67 7 3.67s5.5-1.1 5.5-3.67-5.14-8.45-5.14-8.45 1.1-3.3-.36-5.13-14.68-13.22-16.52-16.89-1.47-4.4-2.57-6.24-7.71-9.17-7.71-9.17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M428.41 588.45l10.48 7.76s4.77 0 8.07 1.83 19.09 13.22 19.09 13.22a14.48 14.48 0 004 0c1.1-.37 7 3.67 7 3.67s5.5-1.1 5.5-3.67-5.14-8.45-5.14-8.45 1.1-3.3-.36-5.13-14.68-13.22-16.52-16.89-1.47-4.4-2.57-6.24-7.71-9.17-7.71-9.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M307.43 413.71a63.67 63.67 0 0010.76 9.06c5.09 3.4 31.7 50.38 33.39 54.34s15.29 41.32 21.51 47.55 14.15 52.08 44.16 58.87 32.83-15.85 34-23.21-10.25-43.58-13.63-53.21-22.07-37.36-25.47-44.11-9.06-38.49-10.75-43.59-1.14-50.94 0-60.56-23.21-70.19-28.87-83.21S352.72 172 351 164.09s-2.83-70.19-2.83-76.42S347.06-124 347.06-124s-104.78-51.53-189.07.56c0 0 54.91 253 58.87 263.22s23.21 88.3 23.78 92.26-.57 10.19 0 17.55 6.22 48.68 5.66 54.91-22.08 97.92-26.61 108.68-23.77 67.92-23.2 73 5.66 13 7.92 17 10.76 11.32 18.11 17.55 18.68 31.13 23.21 36.22 22.64 36.8 24.34 39.06 6.8 14.72 13.59 19.25 13 6.22 23.21 3.39 42.45-6.79 52.07-9.62 26.61-4.53 31.7-5.09 11.89-1.13 18.12 0 19.81 2.26 20.94-1.7 6.23-13.59 1.13-15.28-25.47-4-29.43-10.76-7.93-11.32-17.55-11.89a136.06 136.06 0 00-19.81.57s-19.81-6.23-27.74-5.09-15.85 5.66-20.38 9.62-14.15 11.32-14.15 11.32"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M307.43 413.71a63.67 63.67 0 0010.76 9.06c5.09 3.4 31.7 50.38 33.39 54.34s15.29 41.32 21.51 47.55 14.15 52.08 44.16 58.87 32.83-15.85 34-23.21-10.25-43.58-13.63-53.21-22.07-37.36-25.47-44.11-9.06-38.49-10.75-43.59-1.14-50.94 0-60.56-23.21-70.19-28.87-83.21S352.72 172 351 164.09s-2.83-70.19-2.83-76.42S347.06-124 347.06-124s-104.78-51.53-189.07.56c0 0 54.91 253 58.87 263.22s23.21 88.3 23.78 92.26-.57 10.19 0 17.55 6.22 48.68 5.66 54.91-22.08 97.92-26.61 108.68-23.77 67.92-23.2 73 5.66 13 7.92 17 10.76 11.32 18.11 17.55 18.68 31.13 23.21 36.22 22.64 36.8 24.34 39.06 6.8 14.72 13.59 19.25 13 6.22 23.21 3.39 42.45-6.79 52.07-9.62 26.61-4.53 31.7-5.09 11.89-1.13 18.12 0 19.81 2.26 20.94-1.7 6.23-13.59 1.13-15.28-25.47-4-29.43-10.76-7.93-11.32-17.55-11.89a136.06 136.06 0 00-19.81.57s-19.81-6.23-27.74-5.09-15.85 5.66-20.38 9.62-14.15 11.32-14.15 11.32"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M318.75 565.42s-12.45-34.53-15.28-37.93S287.62 517.3 282 515.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M318.75 565.42s-12.45-34.53-15.28-37.93S287.62 517.3 282 515.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M304.6 525.23c-4.21 11.62 10.59-17.13 7.6-27.32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M304.6 525.23c-4.21 11.62 10.59-17.13 7.6-27.32"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M420.64 504.85s-13.58 11.89-21.51 13.58S381 523 381 523"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M420.64 504.85s-13.58 11.89-21.51 13.58S381 523 381 523"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M405.36 485s-17 4.53-23.21 10.19S371.4 506 371.4 506"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M405.36 485s-17 4.53-23.21 10.19S371.4 506 371.4 506"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M430.26 599.38c-5.66-.57-18.67-1.7-22.07-.57a83 83 0 00-9.62 4.53"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M430.26 599.38c-5.66-.57-18.67-1.7-22.07-.57a83 83 0 00-9.62 4.53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M430.83 532.24s-32.24 7.53-31.34 14.07c1 7.31 5.91 18.86 8.25 22 3.59 4.83 18 11.49 27.05 6.4s9.63-19.81 5.1-27.74-9.06-14.72-9.06-14.72"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M430.83 532.24s-32.24 7.53-31.34 14.07c1 7.31 5.91 18.86 8.25 22 3.59 4.83 18 11.49 27.05 6.4s9.63-19.81 5.1-27.74-9.06-14.73-9.06-14.73z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M464.23 545.6c-4-1.13-14.15 1.7-14.15 1.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M464.23 545.6c-4-1.13-14.15 1.7-14.15 1.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M461.4 493s-7.36-2.26-10.76-.56-13.58 12.45-13.58 12.45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M461.4 493s-7.36-2.26-10.76-.56-13.58 12.45-13.58 12.45"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M369.7 605.61s1.7-12.46 5.66-14.16"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M369.7 605.61s1.7-12.46 5.66-14.16"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M292.15 617.49c.56-6.22 1.7-13 1.7-14.71"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M292.15 617.49c.56-6.22 1.7-13 1.7-14.71"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M272.34 601.08s9.62-3.4 13-4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M272.34 601.08s9.62-3.4 13-4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M391.77 395.6s-7.92-16.41-18.11-19.81"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M391.77 395.6s-7.92-16.41-18.11-19.81"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-3",
    d: "M383.83 553.63a43.67 43.67 0 00-6.6-1.83c-2.57-.37-183.51-154.88-183.51-154.88s-1.47-5.87-3.3-7.34-13.58-11.75-13.58-11.75 2.57-10.64 7.7-14.31 8.08-4.77 9.55-4.4 14.31 10.27 14.31 10.27l4.77 1.47L356.31 485 367 516.57s6.61 8.44 8.08 10.27 4.77 14.32 5.87 16.15 4.77 11.38 4.77 11.38z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M383.83 553.63a43.67 43.67 0 00-6.6-1.83c-2.57-.37-183.51-154.88-183.51-154.88s-1.47-5.87-3.3-7.34-13.58-11.75-13.58-11.75 2.57-10.64 7.7-14.31 8.08-4.77 9.55-4.4 14.31 10.27 14.31 10.27l4.77 1.47L356.31 485 367 516.57s6.61 8.44 8.08 10.27 4.77 14.32 5.87 16.15 4.77 11.38 4.77 11.38z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M362.91 540.79c-2.93.37-17.61 5.5-18.71 6.61s-7 1.46-7 1.46-3.67-11.74-10.64-15-19.8-7.15-23.11-6.33"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M362.91 540.79c-2.93.37-17.61 5.5-18.71 6.61s-7 1.46-7 1.46-3.67-11.74-10.64-15-19.8-7.15-23.11-6.33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M329.91 513.4s-8.1 4.63-10.3 7.2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M329.91 513.4s-8.1 4.63-10.3 7.2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M350.07 529.41a33.21 33.21 0 00-2.94 6.24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M350.07 529.41a33.21 33.21 0 00-2.94 6.24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-1",
    d: "M340.53 548.5s-5.51 4.77-6.24 7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M340.53 548.5s-5.51 4.77-6.24 7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-3",
    d: "M439.62 595.84s19.08-5.5 19.82-17.25"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M439.62 595.84s19.08-5.5 19.82-17.25"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-3",
    d: "M466.05 611.26s10.27-2.21 11.37-8.45"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M466.05 611.26s10.27-2.21 11.37-8.45"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-3",
    d: "M481.93 612.57l1.83 3.3-3.66-1.47"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M481.93 612.57l1.83 3.3-3.66-1.47"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-4",
    d: "M178.3 378.2s7.34-.37 12.48-8.07c2.84-4.26 2.94-8.44 2.57-9.55"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M178.3 378.2s7.34-.37 12.48-8.07c2.84-4.26 2.94-8.44 2.57-9.55"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-4",
    d: "M193.72 395.08a27.31 27.31 0 0013.58-9.9c3.73-5.23 4.77-11.75 5.14-13.59"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "hand-top_svg__cls-2",
    d: "M193.72 395.08a27.31 27.31 0 0013.58-9.9c3.73-5.23 4.77-11.75 5.14-13.59"
  })));
}
export default __webpack_public_path__ + "7e60b98c5f77133b5e82e2335d2ea681.svg";
export { SvgHandTop as ReactComponent };